import React,{useState, useCallback} from "react"
import Modal  from "react-bootstrap/Modal"
import { Container, Button} from "react-bootstrap"

//import bcrypt from 'bcryptjs'
import bcrypt from "bcryptjs-react"
import {useNavigate} from 'react-router-dom' 
import { useMutation } from "@apollo/client"
import { useDispatch} from 'react-redux'
import { useSelector } from "react-redux"

import { AutoryzacjaKonkurs } from "../Graphql/mutacjon"
import { zapisLogin,delLogin } from '../Magazyn/kreatorAkcji'
import { schematKonkurs, formData, uiSchemat } from "../Formularze/schematKonkurs"
import Form from "@rjsf/mui"
import validator from "@rjsf/validator-ajv8"


const LogowanieKonkurs = (props)=>{
    const [openModal,setOpenModal] = useState(true);
    const [blad,setBlad] = useState(true)
    const nawigacja = useNavigate()
    const opcje = useSelector((magazyn) => magazyn.opcje)
    const konkursy = useSelector((magazyn) => magazyn.konkursy)
    const tabKonkurs = konkursy.filter(konkurs => konkurs.id_konkursu === opcje.id_konkursu)
    const konkurs = tabKonkurs[0]
    sessionStorage.clear()
    const dispach   = useDispatch()
    const [login] = useMutation(AutoryzacjaKonkurs,{
        onCompleted: dane => {
            sessionStorage.setItem('token',dane.autoryzacjaKonkurs.token)
            dispach(delLogin(dane))
            dispach(zapisLogin({   
                  id: Number(dane.autoryzacjaKonkurs.id),
                  imie: dane.autoryzacjaKonkurs.imie,
                  nazwisko: dane.autoryzacjaKonkurs.nazwisko,
                  token : dane.autoryzacjaKonkurs.token}))
            let url = '/'
            if (props.tryb === 'L') {url = '/konkurs'} 
            if (props.tryb === 'W') {url = '/koniec'}
            nawigacja(url)
            setOpenModal(!openModal)
        }, 
        onError : dane =>{
            setBlad(false)
        }   
    })
        const powrot = (event) => {
        sessionStorage.clear()
        props.funkcjaWidok('K')
   }
    const zamkniecieOkna = () => {setOpenModal(!openModal)}
    
    const submit = useCallback(({formData},e) => {
        const saltKod    = bcrypt.genSaltSync(13)
        const kod_hash   = bcrypt.hashSync(formData.haslo,saltKod)    
        const obj = {
            login : formData.login.toLowerCase(),
            kod : kod_hash,
            idKonkursu : formData.idKonkurs
       }      
        login({variables: {dane: obj}})        
    },[login])
   
    const daneLogowania = {...formData,idKonkurs:Number(opcje.id_konkursu)}
    return (
        <Modal show={openModal} onHide={zamkniecieOkna} className="modal fade" 
        backdrop="static" size="lg"
        aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header className="naglowekModal">
                <Modal.Title>
                    <img src={process.env.PUBLIC_URL + "/KMP_rozeta.png"} alt="Logo KMP"/>
                    <h2 className="napis_login">Autoryzacja do konkursu</h2>
                    <h3 className="textYellow">Ogłoszenie nr : {konkurs.nr_ogloszenia} Na Stanowisko : {konkurs.nazwa_stanowiska} w {konkurs.jednostka}</h3>
                    </Modal.Title>
            </Modal.Header>
            <Modal.Body className="bodyModal">
            <Container>
            <Form
            schema={schematKonkurs}
            uiSchema={uiSchemat}
            onSubmit={submit}
            validator={validator}
            //customValidate = {customizeValidator}
            formData={daneLogowania}>
            <Button className="przyciskLogowanie" onClick={powrot} variant="outline-danger" type="button" size="lg">Rezygnacja</Button>    
            <Button className="przyciskLogowanie" variant="outline-primary" type="submit" size="lg">Autoryzacja</Button>
            </Form>
            </Container>
            </Modal.Body>
            <Modal.Footer className="naglowekModal">
                {!blad && <span className="akcent-den"> Podano błędny adres mail lub kod konkursu</span> }
            </Modal.Footer>
        </Modal>
        )
}

export default LogowanieKonkurs